'use client'

import { Button } from '@mui/material'
import { useState } from 'react'
import StayInTouch from '../shared/StayInTouch'

/**
 * this component provides a <Button> that when click will transform into a contact form.
 *
 */

const ExecedContactForm = ({ post }) => {
  const [formOpen, setFormOpen] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const contactType = post?.button?.action?.selected // form, link, modal
  const buttonTitle = post?.button?.title

  const onClick = () => {
    if (contactType === 'form') {
      setFormOpen(true)
    } else if (contactType === 'link') {
      window.location.href = post?.button?.action?.url
    } else {
      setModalOpen(true)
    }
  }

  return (
    <div className="tw:space-y-4">
      {formOpen ? (
        <StayInTouch
          title={
            post?.button?.action?.form_message ||
            `I'm interested in ${post?.title}`
          }
          formInfo={{
            program: `ExecEd: ${post?.title}`,
            brochureLink: post?.course_detail?.brochure?.url || '',
            slug: 'execed-page',
            utmSource: 'sasin website',
            utmMedium: 'Sasin Main Web / ExecEd Page',
          }}
        />
      ) : (
        <div>
          <Button
            sx={{
              borderRadius: '0.25rem',
            }}
            variant="contained"
            fullWidth
            onClick={() => onClick()}
          >
            <strong className="tw:uppercase tw:tracking-wide">
              {buttonTitle}
            </strong>
          </Button>
        </div>
      )}
      {modalOpen ? (
        <div>
          <h2>Contact Us</h2>
          <form>
            <input type="text" placeholder="Name" />
          </form>
        </div>
      ) : null}
    </div>
  )
}

export default ExecedContactForm
